<router-outlet></router-outlet>
<toast></toast>
<div class="pos-fixed" style="bottom: 0px; width: 100%">
    <div dzProgressBar></div>
</div>
